export default "__VITE_ASSET__D4p3kx5u__"